module.exports = __webpack_public_path__ + "static/media/two.79587b98.svg";